import { useEffect, useRef } from 'react'
import { FestivalHero } from './FestivalHero.tsx'
import { Countdown } from './FestivalStatus.tsx'

// no program yet: four quiet houses on the hill, one window flickering
const GATE_VENUES = ['a', 'b', 'c', 'd'].map((key) => ({
	key,
	concerts: [] as number[],
}))

const COPY: Record<string, { heading: string; text: string | null }> = {
	MAINTENANCE: {
		heading: 'Nettsida er under vedlikehald',
		text: 'Vi jobbar med nettsida. Prøv igjen litt seinare.',
	},
	PLANNING: {
		heading: 'Festivalen er under planlegging',
		text: 'Program og billettar for neste festival blir lagde ut når alt er klart.',
	},
}

/**
 * What the public sees while the festival is not live: the night scene, a
 * note about why, and in COUNTDOWN mode a rolling countdown to when the doors
 * open (the page then reloads itself into the festival site).
 */
export function FestivalGate({
	mode,
	message,
	releaseAt,
	now,
}: {
	mode: string
	message: string | null
	releaseAt: Date | string | null
	now: Date
}) {
	const opensAt = mode === 'COUNTDOWN' && releaseAt ? new Date(releaseAt) : null
	const opensAtMs = opensAt?.getTime() ?? null
	const waiting = opensAtMs != null && opensAtMs > now.getTime()

	// The doors open on their own when the countdown runs out — but only when
	// this browser's clock sees the moment pass, so a clock that runs ahead of
	// the server can never get stuck reloading.
	const sawWaiting = useRef<boolean | null>(null)
	useEffect(() => {
		if (opensAtMs == null) return
		const stillWaiting = opensAtMs > Date.now()
		if (sawWaiting.current === null) sawWaiting.current = stillWaiting
		else if (sawWaiting.current && !stillWaiting) {
			sawWaiting.current = false
			window.location.reload()
		}
	}, [opensAtMs, now])

	const copy =
		mode === 'COUNTDOWN'
			? { heading: message ?? 'Snart opnar vi dørene', text: null }
			: (COPY[mode] ?? COPY.PLANNING!)

	return (
		<main className="hk hk-gate">
			<FestivalHero
				variant="gate"
				eyebrow="Vorrå, Karmøy"
				title="Huskonsertfestivalen på Vorrå"
				titleLines={['Huskonsert-', 'festivalen', 'på Vorrå']}
				lede={
					<>
						<h2 className="hk-gate-heading">{copy.heading}</h2>
						{copy.text ? <p>{copy.text}</p> : null}
					</>
				}
				status={
					opensAt && waiting ? (
						<div className="hk-status">
							<Countdown target={opensAt} now={now} label="Dørene opnar om" />
						</div>
					) : null
				}
				venues={GATE_VENUES}
			/>
		</main>
	)
}
